import { useState } from "react";
import { Ruler } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RubricEditor, RubricSummary, QualityMix, TierBadge, WeekdayInsights } from "@/components/rubric/RubricParts";

export function ClinicianRubricRow({ clientId, habit, onSent }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(null);
  const [note, setNote] = useState("");
  const start = () => { setDraft({ ...habit.rubric, counts_from: habit.rubric.counts_from || "showed_up" }); setNote(""); setOpen(true); };
  const send = async () => {
    const { version, proposed_by, set_at, why, ...rubric } = draft;
    try {
      await api.post(`/clinician/client/${clientId}/habits/${habit.id}/rubric/propose`, { rubric, note });
      toast.success("Proposed — the member decides whether to switch to it.");
      setOpen(false);
      onSent?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send that proposal");
    }
  };
  return (
    <div className="mt-1.5" data-testid={`clinician-rubric-${habit.id}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <Ruler className="w-3 h-3 text-stone-400" />
        <RubricSummary rubric={habit.rubric} />
        {habit.today_tier && habit.rubric?.type !== "yesno" && <TierBadge tier={habit.today_tier} label={`today: ${habit.rubric.tiers.find((t) => t.key === habit.today_tier)?.label || habit.today_tier}`} />}
        {!open && <button onClick={start} data-testid={`clinician-rubric-propose-${habit.id}`} className="text-[11px] font-semibold text-amber-800 hover:text-amber-900">Propose a change</button>}
      </div>
      <QualityMix mix={habit.tier_mix} testid={`clinician-quality-${habit.id}`} />
      <WeekdayInsights insights={habit.insights} rubric={habit.rubric} compact testid={`clinician-weekday-${habit.id}`} />
      {habit.rubric_proposal && <div className="text-[11px] text-stone-500 mt-1" data-testid={`clinician-rubric-pending-${habit.id}`}>Your proposal is waiting for the member's answer.</div>}
      {open && draft && (
        <div className="mt-3 rounded-2xl bg-stone-50 border border-stone-200 p-4 space-y-3">
          <RubricEditor value={draft} onChange={setDraft} idPrefix={`c-rubric-${habit.id}`} showCountsFrom />
          <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={400} data-testid={`clinician-rubric-note-${habit.id}`}
            placeholder="Why this change? (the member sees this)" className="w-full px-3 py-2 rounded-xl border border-stone-300 text-sm outline-none focus:border-amber-600" />
          <div className="flex gap-2">
            <button onClick={send} data-testid={`clinician-rubric-send-${habit.id}`} className="amber-btn text-xs py-2">Send proposal</button>
            <button onClick={() => setOpen(false)} className="text-xs font-semibold text-stone-500 px-3">Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
